import './Button.css';
import React, { JSX } from 'react';

export type Props = {
  readonly onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  readonly type?: 'button' | 'submit' | 'reset';
  readonly secondary?: boolean;
  readonly danger?: boolean;
  readonly disabled?: boolean;
  readonly rounded?: boolean;
  readonly dataCy?: string;
  readonly className?: string;
  readonly children: React.ReactNode;
};

export function Button({
  type = 'button',
  disabled = false,
  onClick,
  dataCy,
  secondary,
  danger,
  rounded,
  className = '',
  children,
}: Props): JSX.Element {
  const secondaryClass = secondary ? 'button--secondary' : '';
  const dangerClass = danger ? 'button--danger' : '';
  const roundedClass = rounded ? 'button--rounded' : '';

  return (
    <button
      className={`button ${secondaryClass} ${dangerClass} ${roundedClass} ${className}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      data-cy={dataCy}
    >
      {children}
    </button>
  );
}
